<template>
    <span>
    <span style="position: absolute">
    <v-fade-transition><v-icon key="0" :color="dark ? 'white' : 'black'" style="position: absolute; opacity: 0.2" v-if="school_state == 'no' && training_state == 'no'">fiber_manual_record</v-icon></v-fade-transition>
    <v-fade-transition><span key="1" v-if="school_state == 'normal'">
        <v-icon v-if="training_state != 'no'" :color="dark ? 'error' : 'error darken-2'" style="position: absolute; filter: blur(2pt)">school</v-icon>
        <v-icon :color="dark ? 'white' : 'black'" style="position: absolute" :style="{opacity: training_state != 'no' ? null : 0.2}">school</v-icon>
    </span></v-fade-transition>
    <v-fade-transition><span key="2" v-if="school_state == 'biweekly_0'">
        <v-icon v-if="training_state != 'no'" :color="dark ? 'error' : 'error darken-2'" style="position: absolute; filter: blur(2pt)">school</v-icon>
        <v-badge offset-y="8" offset-x="8" overlap style="position: absolute" color="rgba(0, 0, 0, 0.0)"><v-icon slot="badge" :class="dark ? null : 'black--text'">cached</v-icon><v-icon :style="{opacity: training_state != 'no' ? null : 0.2}" :color="dark ? 'white' : 'black'">school</v-icon></v-badge>
    </span></v-fade-transition>
    <v-fade-transition><span key="3" v-if="school_state == 'biweekly_1'">
        <!-- <v-icon v-if="training_state != 'no'" :color="dark ? 'error' : 'error darken-2'" style="position: absolute; filter: blur(2pt)">directions_run</v-icon> -->
        <v-badge offset-y="8" offset-x="8" overlap style="position: absolute" color="rgba(0, 0, 0, 0.0)"><v-icon slot="badge" :class="dark ? null : 'black--text'">cached</v-icon><v-icon :style="{opacity: training_state != 'no' ? null : 0.2}" :color="dark ? 'white' : 'black'" v-text="training_state == 'morning' ? 'alarm' : (training_state == 'normal' ? 'directions_run' : 'fiber_manual_record')"></v-icon></v-badge>
    </span></v-fade-transition>
    <v-fade-transition><v-icon key="4" :color="dark ? 'white' : 'black'" style="position: absolute" v-if="training_state == 'normal' && school_state == 'no'">directions_run</v-icon></v-fade-transition>
    <v-fade-transition><v-icon key="5" :color="dark ? 'white' : 'black'" style="position: absolute" v-if="training_state == 'morning' && school_state == 'no'">alarm</v-icon></v-fade-transition>
    </span>
    <v-icon style="opacity: 0.0">fiber_manual_record</v-icon>
    </span>
</template>

<script>

export default {
    name: 'SchoolIcon',
    props: {
        school_state: String,
        training_state: String,
        dark: Boolean
    }
}

</script>

<style>

.v-badge__badge .v-icon {
    color: inherit;
    font-size: 12px;
    margin: 0 -2px;
}

</style>
